var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step === 1
        ? [
            _c("h3", { staticClass: "color-primary" }, [
              _vm._v("Neue Terminvorschläge")
            ]),
            _vm._v(" "),
            _c("AppointmentInfos", {
              attrs: { appointment: _vm.appointment, type: "customer" }
            }),
            _vm._v(" "),
            _c("DateChoiceOrProposal", {
              attrs: { appointment: _vm.appointment, type: "customer" },
              model: {
                value: _vm.dateChoiceOrProposalData,
                callback: function($$v) {
                  _vm.dateChoiceOrProposalData = $$v
                },
                expression: "dateChoiceOrProposalData"
              }
            }),
            _vm._v(" "),
            _c("PopUpActions", {
              attrs: {
                "with-back": false,
                "continue-text": "Weiter",
                "continue-disabled": !_vm.dateChoiceOrProposalDataValid
              },
              on: {
                continue: function($event) {
                  _vm.step = 2
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 2
        ? [
            _vm.dateChoiceOrProposalData.counterProposalDates
              ? [
                  _vm.dateChoiceOrProposalData.counterProposalDates.length > 0
                    ? _c("JonInfo", {
                        staticClass: "mt-0 mb-2",
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "message",
                              fn: function() {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "Bitte überprüfe deine vorgeschlagenen Termine auf Korrektheit:"
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          72307890
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(
                    _vm.dateChoiceOrProposalData.counterProposalDates,
                    function(date) {
                      return _c(
                        "div",
                        { key: date.id, class: ["font-weight-bold"] },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm._f("fullDateTimeByDateAndTime")(date)
                              ) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    }
                  )
                ]
              : _c("JonInfo", {
                  staticClass: "mt-0",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "message",
                        fn: function() {
                          return [
                            _vm._v("\n\t\t\t\tDu hast den Termin "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("fullDateTime")(
                                    _vm.dateChoiceOrProposalData.chosenDate
                                      .timeStamp
                                  )
                                )
                              )
                            ]),
                            _vm._v("\n\t\t\t\tgewählt."),
                            _c("br"),
                            _vm._v(
                              '\n\t\t\t\tNach Klick auf "Termin bestätigen" informieren wir die Person, dass du den Termin angenommen hast.\n\t\t\t'
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2500035110
                  )
                }),
            _vm._v(" "),
            _c("PopUpActions", {
              staticClass: "mt-3",
              attrs: {
                "continue-text": _vm.dateChoiceOrProposalData.chosenDate
                  ? "Termin bestätigen"
                  : "Terminvorschläge schicken",
                "continue-loading": _vm.sendingRequest,
                "continue-disabled": _vm.sendingRequest
              },
              on: {
                back: function($event) {
                  _vm.step = 1
                },
                continue: _vm.sendRequest
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }